import React from 'react';
import { clsx } from 'clsx';
import { CurrentIntegration } from 'src/pages/ControlDeskPage/IntegrationStatusSection/CurrentIntegrationField/CurrentIntegration/CurrentIntegration';

export const CurrentIntegrations = ({
  integrations = [],
  isEmpty,
  isFetchingProject,
  integrationTypes,
}) => {
  return (
    <div>
      {!isEmpty ? (
        integrations.map((integration) => {
          return (
            <CurrentIntegration
              key={integration.id}
              integrationTypes={integrationTypes || []}
              integration={integration}
            />
          );
        })
      ) : (
        <div>
          <div className="font-medium table-fixed max-w-80">
            <div
              className={clsx(
                isFetchingProject && 'blur-sm animate-pulse',
                'col md:h-10 h-8 flex items-center',
              )}
            >
              <p className="opacity-30 font-jamjuree font-medium text-sm truncate">
                AI is not connected to a help desk
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
